// Setup: Configure vendor plugins
// The purpose of this file is to configure misc 3rd party plugins.
// It is included after the plugins, but before the application code.

// Needed for ie9 to embed dynamic vimeo objects.
$.support.cors = true;